import { Tooltip } from "antd"
import type React from "react"
import { useTranslation } from "react-i18next"

import {
  MILESTONE_STATUSES_MAP,
  type MilestoneStatuses
} from "../../../../constants/milestone-statuses.ts"
import { StatusTag } from "../../../StatusTag.tsx"

const statusData = (status: unknown) =>
  MILESTONE_STATUSES_MAP[status as MilestoneStatuses] as
    | (typeof MILESTONE_STATUSES_MAP)[MilestoneStatuses]
    | undefined

export function MilestoneStatusTag({
  status,
  label,
  style
}: {
  status?: number | null
  label?: React.ReactNode
  style?: React.CSSProperties
}) {
  const data = statusData(status)

  return (
    <StatusTag
      style={{ ...data?.style, ...style }}
      tooltipKey={data?.tooltipKey}
      label={label}
    />
  )
}

export function MilestoneStatusOption({
  value,
  label
}: {
  value?: unknown
  label?: React.ReactNode
}) {
  const { t } = useTranslation()
  const data = statusData(value)

  if (!data) return <>{label}</>

  return (
    <Tooltip title={t(data.tooltipKey)} placement="right" mouseEnterDelay={0.3}>
      <span className="block">{label}</span>
    </Tooltip>
  )
}

export const renderMilestoneStatusOption = (option: {
  value?: unknown
  label?: React.ReactNode
}) => <MilestoneStatusOption value={option.value} label={option.label} />
